import { Stack } from "@mui/material";
import { Outlet } from "react-router-dom";
import { useLangContext } from "../../context/langContext";
import SidebarComponent from "../../components/login/Sidebar/Sidebar";

export default function AuthLayout() {
  const { dir } = useLangContext();
  return (
    <Stack dir={dir} direction="column" gap="2" height="100vh">
      <Stack width="100%" direction="row" height="90vh">
        <Stack
          width={{ xs: "100%", md: "50%" }}
          alignItems="center"
          height="80vh"
          justifyContent="center"
        >
          <Stack
            width={{ xs: "100%", md: "70%" }}
            alignItems="center"
            justifyContent="center"
          >
            <Outlet />
          </Stack>
        </Stack>
        <Stack
          width={{ xs: "0", md: "50%" }}
          display={{ xs: "none", md: "flex" }}
          height="80vh"
        >
          <SidebarComponent />
        </Stack>
      </Stack>

      {/* <CopyRightComponent /> */}
    </Stack>
  );
}
